import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import DynamicForm from "../../../../../components/modules/ClientDetail/Case/DynamicForm";
import InvalidContent from "../../../../../components/modules/ClientDetail/Case/DynamicForm/components/InvalidContent";
import { mapPermissions } from "../../../../../components/modules/ClientDetail/Case/utils/functions";
import { coverageLayout } from "../../../../../components/modules/ClientDetail/Case/utils/layouts";
import { coverageValidations } from "../../../../../components/modules/ClientDetail/Case/utils/validations";
import Navigation from "../../../../../components/navigations/client/detail/case/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);
  const { clientCoverage, clientCoverageHistory } = useLoaderData();
  const currentUserService = inject("current-user-service");
  const clientCovergaeRepository = useService("repositories/client-coverage-repository");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canEdit = userPermissions.includes("casemanager.change_clientcoverage");
  const canView = userPermissions.includes("casemanager.view_clientcoverage");
  const mappedLayout = mapPermissions(coverageLayout, canEdit);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/case/coverage-and-liability");
  }, []);

  return (
    <Navigation activeTab="coverage-and-liability" _case={_case}>
      {canView ? (
        <DynamicForm
          conditionalRules={coverageValidations}
          data={clientCoverage}
          formLayout={mappedLayout}
          formRepository={clientCovergaeRepository}
          historyData={clientCoverageHistory}
        />
      ) : (
        <InvalidContent />
      )}
    </Navigation>
  );
};
